import React, { useState } from 'react';
import Switch from "react-switch"
import { Row, Col, Card, CardBody, Button, Container } from "reactstrap"

const DPSwitch = ({ checked, onChange, onSymble, offSymble }) => {

    return (
        <Switch
            onChange={onChange}
            checked={checked}
            className="react-switch"
            uncheckedIcon={offSymble}
            checkedIcon={onSymble}
            onColor="#626ed4"
            height={23}
            handleDiameter={10}
        />
    );
}

export default DPSwitch;